import 'react-datepicker/dist/react-datepicker.css';

import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import { useWindowSize } from 'react-use';

import styles from './styles/styles.module.css';
// import { useAppSelector } from '../../../store/store';

function CustomDatePicker({
  inputName,
  placeholderText,
  validationRules,
  disabled,
  includesDate,
}) {
  const {
    control,
    register,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const { width } = useWindowSize();
  const inputValue = watch(inputName);
  const error = errors[inputName];
  // const { pathname } = useLocation();
  // const tomorrow = new Date();
  // const storedOrder = sessionStorage.getItem('order');
  // const parsedStoredOrder = storedOrder ? JSON.parse(storedOrder) : null;
  // const effectiveOrder = parsedStoredOrder;

  // const sendForm = useAppSelector((state) => state.deliveryForm);
  // let effectiveMinDate = minDate;

  // if (!effectiveMinDate) {
  //   if (pathname === '/refund' || sendForm.need_delivery)
  //     effectiveMinDate = new Date(tomorrow.setDate(tomorrow.getDate() + 1));
  //   else if (effectiveOrder)
  //     if ('items' in effectiveOrder || effectiveOrder.title === 'Забор груза')
  //       effectiveMinDate = new Date(tomorrow.setDate(tomorrow.getDate() + 1));
  //     else effectiveMinDate = tomorrow;
  // }

  // const currentYear = new Date().getFullYear();

  // const year = 2026;

  // const sundays = [];

  // let dateTime = new Date(year, 0, 1);

  // while (dateTime.getFullYear() === year) {
  //   if (dateTime.getDay() === 0) {
  //     sundays.push(new Date(dateTime));
  //   }
  //   dateTime.setDate(dateTime.getDate() + 1);
  // }

  // const holidays = [
  //   new Date(currentYear, 0, 1),
  //   new Date(currentYear, 0, 2),
  //   new Date(currentYear, 0, 3),
  //   new Date(currentYear, 0, 4),
  //   new Date(currentYear, 0, 5),
  //   new Date(currentYear, 0, 6),
  //   new Date(currentYear, 0, 7),
  //   new Date(currentYear, 1, 23),
  //   new Date(currentYear, 2, 8),
  //   new Date(currentYear, 2, 9),
  //   new Date(currentYear, 2, 29),
  //   new Date(currentYear, 4, 1),
  //   new Date(currentYear, 4, 9),
  //   new Date(currentYear, 4, 11),
  //   new Date(currentYear, 5, 12),
  //   new Date(currentYear, 10, 4),
  //   new Date(currentYear, 11, 31),
  //   ...sundays,
  // ];

  const allowedDates = (includesDate || []).map((dateStr) => {
    const [day, month, year] = dateStr.split('.');
    return new Date(year, month - 1, day);
  });

  // const maxDateFromToday = new Date();
  // maxDateFromToday.setDate(maxDateFromToday.getDate() + 14);
  // console.log(includesDate);
  return (
    <Controller
      control={control}
      name={inputName}
      rules={validationRules}
      render={({ field }) => (
        <ReactDatePicker
          includeDates={allowedDates}
          className={`${disabled ? styles.disabledDatePicker : ''}`}
          readOnly={disabled}
          disabled={disabled}
          // excludeDateIntervals={excludedIntervals}
          selected={
            field.value ? new Date(field.value.split('.').reverse().join('-')) : null
          }
          onChange={(date) => {
            const formattedDate = date ? date.toLocaleDateString('ru-RU') : '';
            field.onChange(formattedDate);
          }}
          dateFormat="dd.MM.yyyy"
          // minDate={effectiveMinDate}
          customInput={
            <input
              {...register(inputName, validationRules)}
              type="text"
              inputMode="none"
              autoComplete="off"
              className={`
                  ${styles.input}
                  ${!error ? '' : styles.input_error}
                  ${error && !inputValue ? styles.input_errorIcon : ''}
                  `}
              placeholder={placeholderText}
              id={inputName}
              onFocus={() => clearErrors(inputName)}
            />
          }
          calendarClassName={styles.customCalendar}
          popperClassName={styles.customPopper}
          dayClassName={() => `${styles.customDay}`}
          popperPlacement={width < 480 ? 'bottom-center' : 'bottom-start'}
          locale={ru}
          onFocus={() => clearErrors(inputName)}
          renderCustomHeader={({
            date,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled,
          }) => (
            <div className={styles.customHeader}>
              <button
                type="button"
                onClick={decreaseMonth}
                disabled={prevMonthButtonDisabled}
                className={styles.navButton}
              />
              <span className={styles.monthYear}>
                {format(date, 'LLLL yyyy', { locale: ru }).replace(/^./, (char) =>
                  char.toUpperCase()
                )}
              </span>
              <button
                type="button"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}
                className={`${styles.navButton} ${styles.navButton_next}`}
              />
            </div>
          )}
        />
      )}
    />
  );
}

export default CustomDatePicker;

CustomDatePicker.propTypes = {
  inputName: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  validationRules: PropTypes.shape({}),
  disabled: PropTypes.bool,
  includesDate: PropTypes.arrayOf(PropTypes.string),
  // minDate: PropTypes.instanceOf(Date),
};
